import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  agencyHasFeature,
  isAgencyAdmin,
  isAgencyUser,
  isGroupAdmin,
  isGroupUser,
  isRolePlatformAdmin,
  token,
} from "../../../modules/auth";
import {
  fetchHotelGroups,
  fetchHotelGroupTypes,
  hotelGroupsUnload,
  hotelGroupTypesUnload,
} from "../../../redux/actions";
import HotelGroupsList from "../../../Components/HotelGroups/HotelGroupsList";
import Loading from "../../../Components/Loading";
import TailwindPagination from "../../../ui/TailwindPagination";
import HotelGroupFilters from "../../../Components/HotelGroups/HotelGroupFilters";
import useParams from "hooks/useParams";
import { useHistory, Link } from "react-router-dom";
import HotelGroupAddGroupToProgram from "../../../Components/HotelGroups/HotelGroupAddGroupToProgram";
import PreferredProgrammeHotelGroupsList from "../../../Components/PreferredProgrammes/PreferredProgrammeHotelGroupsList";
import { isCompanyAdmin, isCompanyUser } from "../../../modules/permissions";
import { ButtonPrimary, ButtonTertiary } from "../../../Components/Button";
import * as ROUTES from "../../../Router/venue_routes";
import AgencyFeatures from "../../../Components/corporate/agency/AgencyFeatures";
import { AGENCY_PERMISSIONS } from "../../../constants";

const HotelGroupsContainer = ({
  token,
  fetchHotelGroups,
  hotelGroups,
  hotelGroupsPage,
  hotelGroupsLastPage,
  isFetchingHotelGroups,
  hotelGroupsUnload,
  hotelGroupsTotalPages,
  hotelGroupsTotalResults,
  hotelGroupPerPageLimit,
  fetchHotelGroupTypes,
  hotelGroupTypesUnload,
  hotelGroupTypes,
  location,
  isHotelGroupAdmin,
  isHotelGroupUser,
  isAgencyAdmin,
  isCompanyAdmin,
  isAgencyUser,
  isCompanyUser,
  isRolePlatformAdmin,
  preferredPrograms,
  selectedAgencies,
  isCorporate = false,
  canHaveCommercialDeals
}) => {
  const [page, setPage] = useState(hotelGroupsPage);
  const [hotelGroupType, setHotelGroupType] = useState();
  const searchTermRef = useRef();
  const [queryParams, setQueryParams] = useState(null);
  const [showAddRow, setShowAddRow] = useState(false);
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const params = useParams(location?.search);
  const history = useHistory();

  useEffect(() => {
    hotelGroupsUnload();
    hotelGroupTypesUnload();
    fetchHotelGroupTypes(token);
    fetchHotelGroups(token, preferredPrograms, page);
    return () => {
      hotelGroupsUnload();
      hotelGroupTypesUnload();
    };
  }, []);

  useEffect(() => {
    fetchHotelGroupTypes(token);
    fetchHotelGroups(token, preferredPrograms, page);
    return () => {
      hotelGroupsUnload();
      hotelGroupTypesUnload();
    };
  }, [selectedAgencies]);

  useEffect(() => {
    if (queryParams === null) {
      history.push({
        page: page ? page : 1,
      });
      fetchHotelGroups(token, preferredPrograms, page);
    }
  }, [queryParams]);

  useEffect(() => {
    if (params && params.page !== queryParams?.page) {
      handlePageChange(params.page);
    }
  }, [params]);

  useEffect(() => {
    setQueryParams(prev => ({
      ...prev,
      groupType: hotelGroupType,
      page: page ? page : 1,
    }));
  }, [hotelGroupType]);

  useEffect(() => {
    if (page !== hotelGroupsPage) {
      if (typeof queryParams?.groupType === "undefined") {
        delete queryParams.groupType;
      }
      fetchHotelGroups(token, preferredPrograms, page, queryParams);
    }
  }, [page, token, fetchHotelGroups]);

  const triggerSearch = () => {
    if (queryParams && typeof queryParams.groupType === "undefined") {
      delete queryParams.groupType;
    }
    if ( preferredPrograms ) {
      queryParams.restrict = 1;
    }else{
      delete queryParams.restrict;
    }
    fetchHotelGroups(token, preferredPrograms, page, queryParams);
  };
  useEffect(() => {
    setQueryParams(prev => ({
      ...prev,
      agency:
        selectedAgency && selectedAgency.value ? selectedAgency.value : "",
      company: "",
    }));
  }, [selectedAgency]);

  useEffect(() => {
    setQueryParams(prev => ({
      ...prev,
      company:
        selectedCompany && selectedCompany.value ? selectedCompany.value : "",
      agency: "",
    }));
  }, [selectedCompany]);
  const handlePageChange = useCallback(
    page => {
      setPage(page);
      setQueryParams(prev => ({
        ...prev,
        page,
      }));
      const searchParams = new URLSearchParams(location.search || "");
      if (typeof page !== "undefined") {
        searchParams.set("page", page);
        history.push({
          ...location,
          search: searchParams.toString(),
        });
      }
    },
    [history, location, setPage, setQueryParams]
  );

  const setSearchTerm = query => {
    setQueryParams(() => ({
      page: 1,
      query,
    }));
  };

  const resetFilters = useCallback(() => {
    setHotelGroupType();
    setSelectedCompany(null);
    setSelectedAgency(null);
    setQueryParams(null);
  }, []);

  if (isFetchingHotelGroups && (!hotelGroups || hotelGroups?.length < 1)) {
    return <Loading />;
  }
  return (
    <div className="pt-10">
      <div className="border-b border-gray-200 sm:rounded-lg bg-white p-5">
        {preferredPrograms ? (
          <h1>Preferred Programmes</h1>
        ) : (
          <h1 className={"my-5"}>Hotel Groups</h1>
        )}

        {preferredPrograms ? (
          <div className={"flex justify-end"}>
            <div className={"py-2 px-2"}>
              <ButtonPrimary onClick={() => setShowAddRow(!showAddRow)}>
                Add a Group / Brand
              </ButtonPrimary>
            </div>
            <div className={"py-2 px-2"}>
              <Link
                to={ROUTES.FRONTEND.PREFERRED_PROGRAMMES.CUSTOM_CREATE}
                className={"text-black"}
              >
                <ButtonTertiary>Create Custom Group</ButtonTertiary>
              </Link>
            </div>
          </div>
        ) : null}
        {showAddRow &&
        (isAgencyAdmin || isCompanyAdmin || isRolePlatformAdmin) ? (
          <div className="border border-gray-500 sm:rounded-lg bg-light-grey p-5 m-5">
            <HotelGroupAddGroupToProgram
              onAddGroup={(programme, group) => {
                window.location.href = `${
                  isCorporate ? "/corporate/" : "/admin/"
                }preferred-programmes/${programme}/hotel-group/${group}/edit`;

              }} />
          </div>
        ) : null}

        {!(isCompanyAdmin || isCompanyUser) ? (
          <HotelGroupFilters
            hotelGroupTypes={hotelGroupTypes}
            searchTermRef={searchTermRef}
            setSearchTerm={setSearchTerm}
            searchTerm={queryParams?.query}
            setHotelGroupType={setHotelGroupType}
            hotelGroupType={hotelGroupType}
            resetFilters={resetFilters}
            triggerSearch={triggerSearch}
            setSelectedAgency={setSelectedAgency}
            selectedAgency={selectedAgency}
            setSelectedCompany={setSelectedCompany}
            selectedCompany={selectedCompany}
            preferredPrograms={preferredPrograms}
            hideGroupType={true}
            isCompany={isCompanyAdmin || isCompanyUser}
          />
        ) : null}
        {isAgencyAdmin ||
        isAgencyUser ||
        isCompanyAdmin ||
        isCompanyUser ||
        (isRolePlatformAdmin && preferredPrograms) ? (
          // location.pathname !== "/admin/venues/hotel-groups") ? (
          <PreferredProgrammeHotelGroupsList
            hotelGroups={hotelGroups}
            isFetchingHotelGroups={isFetchingHotelGroups}
            currentPage={hotelGroupsPage}
            isHotelGroupUser={isHotelGroupUser}
            isHotelGroupAdmin={isHotelGroupAdmin}
            isAgency={isAgencyAdmin || isAgencyUser || isRolePlatformAdmin}
            isCompany={isCompanyAdmin || isCompanyUser}
            token={token}
            canHaveCommercialDeals={canHaveCommercialDeals}
          />
        ) : (
          <HotelGroupsList
            hotelGroups={hotelGroups}
            isFetchingHotelGroups={isFetchingHotelGroups}
            currentPage={hotelGroupsPage}
            isHotelGroupUser={isHotelGroupUser}
            isHotelGroupAdmin={isHotelGroupAdmin}
            isRolePlatformAdmin={isRolePlatformAdmin}
          />
        )}

        <div className="m-3">
          <TailwindPagination
            totalPages={hotelGroupsTotalPages}
            currentPage={hotelGroupsPage}
            totalResults={hotelGroupsTotalResults}
            lastPage={hotelGroupsLastPage}
            pageLimit={hotelGroupPerPageLimit}
            onClick={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.hotelGroups,
    ...state.hotelGroupTypes,
    token: token(state),
    isHotelGroupUser: isGroupUser(state),
    isHotelGroupAdmin: isGroupAdmin(state),
    isAgencyAdmin: isAgencyAdmin(state),
    isAgencyUser: isAgencyUser(state),
    isCompanyAdmin: isCompanyAdmin(state.auth),
    isCompanyUser: isCompanyUser(state.auth),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    selectedAgencies: state.selectedAgencies.selectedAgencies,
    canHaveCommercialDeals: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_MANAGE_COMMERCIAL_DEALS)
  };
};

const mapDispatchToProps = {
  fetchHotelGroups,
  fetchHotelGroupTypes,
  hotelGroupsUnload,
  hotelGroupTypesUnload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HotelGroupsContainer);
